var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'forced',
    _vm.open
      ? _vm.width > _vm.tabSize
        ? ''
        : 'full-layout'
      : _vm.width > _vm.tabSize
      ? 'enlarged'
      : 'full-layout'
  ],attrs:{"id":"wrapper"}},[_c('Header'),_c('Sidebar'),_c('vue-custom-scrollbar',{staticClass:"scroll-area",attrs:{"id":"scroll-area","settings":_vm.settings}},[_c('div',{staticClass:"content"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }